import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Modal } from '@/components/common/AppModal';
import { Button } from 'react-bootstrap';
import IconAlert from '@/components/common/IconAlert';
import { ui } from '../constants';

interface CheckoutFeedbackModalProps {
  show: boolean;
  title: string;
  message: ReactNode;
  variant: 'success' | 'danger' | 'info' | 'warning';
  onClose: () => void;
  showHomeButton?: boolean;
  successRedirectTo?: string;
  successButtonLabel?: string;
}

function CheckoutFeedbackModal({
  show,
  title,
  message,
  variant,
  onClose,
  showHomeButton = true,
  successRedirectTo = '/',
  successButtonLabel = ui.messages.checkoutSuccessGoHome,
}: CheckoutFeedbackModalProps) {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className={`pricing-checkout-feedback-modal pricing-checkout-feedback-modal-${variant}`}
      contentClassName="border-0 shadow-lg"
    >
      <Modal.Body className="p-4 pb-0">
        <IconAlert
          variant={variant}
          dismissible={showHomeButton && variant === 'success'}
          onClose={onClose}
          className="mb-0"
        >
          <strong className="d-block fs-0 text-1000 mb-1">{title}</strong>
          <span>{message}</span>
        </IconAlert>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-3">
        {variant === 'success' ? (
          showHomeButton ? (
            <>
              <Button variant="secondary" size="sm" onClick={onClose}>
                {ui.messages.checkoutErrorModalClose}
              </Button>
              <Button
                as={Link}
                to={successRedirectTo}
                variant="falcon-primary"
                size="sm"
                onClick={onClose}
              >
                {successButtonLabel}
              </Button>
            </>
          ) : (
            <Button variant="falcon-primary" size="sm" onClick={onClose}>
              {ui.messages.checkoutErrorModalClose}
            </Button>
          )
        ) : (
          <Button
            variant={variant === 'danger' ? 'secondary' : 'falcon-primary'}
            size="sm"
            onClick={onClose}
          >
            {ui.messages.checkoutErrorModalClose}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default CheckoutFeedbackModal;
